<template>
  <div>
    <div v-for="tag in visibleTagList.slice(0, 1)" :key="tag" class="d-flex">
      <a class="atom-tag" href="#">
        <span v-tooltip :title="tag">{{ $filters.strLimit(tag, 16) }}</span>
      </a>
      <div v-if="visibleTagList.length > 1" class="atom-expand mt-1" @click="isOpenReal = !isOpenReal">
        <span v-if="isOpenReal">-</span>
        <span v-else>+</span>
        {{ visibleTagList.length - 1 }}
      </div>
    </div>

    <div v-if="isOpenReal" class="atom-expand__content d-flex flex-wrap">
      <div v-for="tag in visibleTagList.slice(1, visibleTagList.length)" :key="tag" class="">
        <a class="atom-tag">
          <span v-tooltip :title="tag">{{ $filters.strLimit(tag, 16) }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getVisibleTags } from "@/plugins/getVisible"
import { useAuthStore } from "@/store/modules/auth"

export default {
  name: "TagBubbles",
  props: {
    tagList: Array,
    isOpen: Boolean
  },
  setup() {
    const authStore = useAuthStore()

    return { authStore }
  },
  data() {
    return {
      isOpenReal: this.isOpen
    }
  },
  watch: {
    isOpen(val) {
      this.isOpenReal = val
    }
  },
  computed: {
    visibleTagList() {
      return getVisibleTags(this.tagList, this.authStore.apiUser?.isIotAdmin)
    }
  }
}
</script>
